import { WorkOrderStatusCode } from "../models/models";

/**
 * Shared transition rules for work order status changes.
 * Used by both WorkOrderDetailPage and WorkBoardPage (drag-and-drop).
 */
export const allowedTransitions: Record<number, number[]> = {
  [WorkOrderStatusCode.Created]: [
    WorkOrderStatusCode.Assigned,
    WorkOrderStatusCode.Scheduled,
    WorkOrderStatusCode.InProgress,
    WorkOrderStatusCode.Cancelled,
  ],
  [WorkOrderStatusCode.Assigned]: [
    WorkOrderStatusCode.Scheduled,
    WorkOrderStatusCode.InProgress,
    WorkOrderStatusCode.Cancelled,
  ],
  [WorkOrderStatusCode.Scheduled]: [
    WorkOrderStatusCode.InProgress,
    WorkOrderStatusCode.Cancelled,
  ],
  [WorkOrderStatusCode.InProgress]: [
    WorkOrderStatusCode.OnHold,
    WorkOrderStatusCode.PendingReview,
    WorkOrderStatusCode.Cancelled,
  ],
  [WorkOrderStatusCode.OnHold]: [
    WorkOrderStatusCode.InProgress,
    WorkOrderStatusCode.Cancelled,
  ],
  [WorkOrderStatusCode.PendingReview]: [
    WorkOrderStatusCode.Completed,
    WorkOrderStatusCode.InProgress,
    WorkOrderStatusCode.Cancelled,
  ],
};

export const isValidTransition = (from: number, to: number): boolean => {
  return (allowedTransitions[from] || []).includes(to);
};

/**
 * Maps kanban column keys to the target status code when a card is dropped.
 * - "backlog" resets to Created (not Assigned).
 * - "completed" triggers completion form overlay (handled separately).
 * - "cancelled" is NOT a valid drop target.
 */
export const columnTargetStatus: Record<string, number> = {
  backlog: WorkOrderStatusCode.Created,
  inProgress: WorkOrderStatusCode.InProgress,
  onHold: WorkOrderStatusCode.OnHold,
  pendingReview: WorkOrderStatusCode.PendingReview,
  completed: WorkOrderStatusCode.Completed,
};
